import * as Actions from "./_ActionTypes";
import * as Pre from "./_PreActionNames";

export function Add(model, accessToken) {
  const act = {
    type: Pre.ELEVATOR + Actions.ADD,
    payload: model,
    socket: { send: true, keepSocket: true },
    accessToken,
  };
  return act;
}
export function Update(model, accessToken) {
  return {
    type: Pre.ELEVATOR + Actions.UPDATE,
    payload: model,
    socket: { send: true, keepSocket: true },
    accessToken,
  };
}

export function Remove(elevatorId, accessToken) {
  return {
    type: Pre.ELEVATOR + Actions.REMOVE,
    payload: { elevatorId },
    socket: { send: true, keepSocket: true },
    accessToken,
  };
}
export function Call(deviceId, deviceUId, floorLevel, accessToken) {
  var payload = { deviceId, deviceUId, floorLevel };
  return {
    type: Pre.ELEVATOR + Actions.CALL,
    payload,
    socket: { send: true, keepSocket: true },
    accessToken,
  };
}

export function SubscribeToTopic(topic, accessToken) {
  return {
    type: Pre.SUBSCRIBE,
    payload: { topic },
    socket: { send: true, keepSocket: true },
    accessToken,
  };
}

export function UnSubscribeToTopic(topic, accessToken) {
  return {
    type: Pre.UNSUBSCRIBE,
    payload: { topic },
    socket: { send: true, keepSocket: true },
    accessToken,
  };
}
export function VIPMode(
  deviceId = 0,
  deviceUId = null,
  vipEnabled = false,
  accessToken
) {
  return {
    type: Pre.ELEVATOR + Actions.VIP,
    payload: { deviceId, deviceUId, vipEnabled },
    socket: { send: true, keepSocket: true },
    accessToken,
  };
}
